module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./AddressDetailsView.js"));
	}, "AddressDetailsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AddressDetailsView!./src/pages/Shop/Member/Address/AddressDetails/AddressDetailsView.js
// module id = 1908
// module chunks = 367